
import { mapGetters } from 'vuex'

export default {
  data: () => ({
    links: [{ name: 'Beranda', Link: '/#' }],
    appName: 'SiTrendi - Sistem Pesantren Digital',
    tawkToSrc: process.env.tawkToSrc
  }),
  computed: {
    ...mapGetters(['isAuthenticated', 'loggedInUser']),
  },
}
